<div class="change-password-card">
  <div class="card-header">
    <mat-icon class="header-icon">security</mat-icon>
    <div class="header-content">
      <h3 class="card-title">{{ title }}</h3>
      <p class="card-description">{{ description }}</p>
    </div>
  </div>
  <div class="card-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="openChangePasswordDialog()">
      <mat-icon>lock</mat-icon>
      {{ buttonLabel }}
    </button>
  </div>
</div>
